// extracted by mini-css-extract-plugin
export default {"mainWrapper":"RDMAcadHome_mainWrapper__4inSc","mainContainer":"RDMAcadHome_mainContainer__XwXJ4","leftCol":"RDMAcadHome_leftCol__bicxJ","rightCol":"RDMAcadHome_rightCol__Q25vT"};